'use client';

import { PageNavigation } from '@/components/client';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';

export const GiftsPageNavigation = () => {
  const router = useCustomRouter();

  return (
    <PageNavigation
      donationHomeButton
      isNotUsedHomeButton
      searchForm
      searchFormClassName="cursor-pointer"
      onSearchFormClick={() => {
        router.push(
          ROUTES.SEARCH.withSearchParams({
            searchParams: { category: 'gifts' },
          }),
        );
      }}
    />
  );
};
